import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import * as _ from "lodash";
import * as moment from "moment";

import { URLSearchParams } from '@angular/http'
import { HttpBackendService } from "app/services/http-backend.service";
import { PagedResult } from "app/models/PagedResult";
import { PlannedService } from "app/models/plannedService";
import { BsDatepickerModule, BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap';
import { PlannedServicesDoneFilterOptions } from "app/dto/plannedServicesDoneFilterOptions";
import { LocationService } from "app/services/location.service";
import { PlannedServiceWork } from "app/models/plannedServiceWork";
import { AssetService } from "app/services/asset.service";
import { PlannedServicesShortListFilterOptions } from "app/dto/plannedServicesShortListFilterOptions";
import { PlannedServicePhotoData } from "app/models/plannedServicePhotoData";
import { PhotoType } from "app/models/photoDataPhotoType";

@Injectable()
export class PlannedServiceService {

  constructor(
    private _http: HttpBackendService
  ) { }

  public getPlanedServicesPerPage(sortBy: string, isDesc: boolean, count: number, skip: number, filterOptions: PlannedServicesDoneFilterOptions): Observable<PagedResult<PlannedService>> {
    let params = new URLSearchParams;
    let filterRequestStrings: string[] = new Array();

    params.append('$orderby', sortBy + (isDesc ? " desc" : " asc"));
    params.append('$select', "Id,Name,Status,Deadline,FinishDate");
    params.append('$expand', "ServiceObject,Works($expand=Asset)");
    params.append('$top', count ? count.toString() : null);
    params.append('$skip', skip ? skip.toString() : null);
    params.append('$count', "true");

    if (filterOptions) {

      if (filterOptions.name)
        filterRequestStrings.push("contains(tolower(Name), '" + filterOptions.name.toLowerCase() + "')");

      if (filterOptions.location)
        filterRequestStrings.push("(contains(tolower(ServiceObject/Name), '" + filterOptions.location.toLowerCase() + "') or contains(tolower(ServiceObject/Address), '" + filterOptions.location.toLowerCase() + "'))");

      if (filterOptions.deadlineRange) {
        if (filterOptions.deadlineRange.length >= 1 && filterOptions.deadlineRange[0])
          filterRequestStrings.push("Deadline ge " + moment(filterOptions.deadlineRange[0]).startOf('day').toISOString());

        if (filterOptions.deadlineRange.length == 2 && filterOptions.deadlineRange[1])
          filterRequestStrings.push("Deadline lt " + moment(filterOptions.deadlineRange[1]).startOf('day').add(1, 'days').toISOString());
      }

      if (filterRequestStrings.length > 0)
        params.append('$filter', _.join(filterRequestStrings, ' and '));
    }

    return this._http.get("/api/odata/PlannedServices", params, true)
      .map(resp => {
        let pagedResult = resp.json();
        let result = new PagedResult<PlannedService>();

        var http = this._http;
        result.items = _.map(pagedResult.value, function (value) {
          return PlannedServiceService.convertPlannedServiceDTO2Object(http, value);
        });

        result.totalCount = pagedResult["@odata.count"];

        return result;
      });
  }

  public getPlanedServicesByAssetPerPage(assetId: number, skip: number, count: number, sortBy: string, isDesc: boolean, filterOptions: PlannedServicesShortListFilterOptions): Observable<PagedResult<PlannedService>> {
    let params = new URLSearchParams;
    let filterRequestStrings: string[] = new Array();

    params.append('$orderby', sortBy + (isDesc ? " desc" : " asc"));
    params.append('$select', "Id,Name,Status,Deadline,FinishDate");
    params.append('$top', count ? count.toString() : null);
    params.append('$skip', skip ? skip.toString() : null)
    params.append('$count', "true");
    params.append('$expand', "Works($expand=Asset)");
    filterRequestStrings.push("Works/any(cso: cso/Asset/Id eq " + assetId + ")");

    if (filterOptions) {

      if (filterOptions.isFinishedInTimeStatus == PlannedServicesShortListFilterOptions.IsFinishedInTimeStatus.FinishedInTime) {
        filterRequestStrings.push(
          "((Status eq ClientPersonalArea.Contracts.Model.PlannedServiceStatus'" + PlannedService.Status.Planned.toString() + "') and (" + moment().toISOString() + " Le Deadline)" +
          "or (Status eq ClientPersonalArea.Contracts.Model.PlannedServiceStatus'" + PlannedService.Status.Done.toString() + "') and (FinishDate Le Deadline))");
      }
      else if (filterOptions.isFinishedInTimeStatus == PlannedServicesShortListFilterOptions.IsFinishedInTimeStatus.Expired) {
        filterRequestStrings.push(
          "((Status eq ClientPersonalArea.Contracts.Model.PlannedServiceStatus'" + PlannedService.Status.Planned.toString() + "') and (" + moment().toISOString() + " Gt Deadline)" +
          "or (Status eq ClientPersonalArea.Contracts.Model.PlannedServiceStatus'" + PlannedService.Status.Done.toString() + "') and (FinishDate Gt Deadline))");
      }

      if (filterRequestStrings.length > 0)
        params.append('$filter', _.join(filterRequestStrings, ' and '));
    }

    return this._http.get("/api/odata/PlannedServices", params, true)
      .map(resp => {
        let pagedResult = resp.json();
        let result = new PagedResult<PlannedService>();

        var http = this._http;
        result.items = _.map(pagedResult.value, function (value) {
          return PlannedServiceService.convertPlannedServiceDTO2Object(http, value);
        });

        result.totalCount = pagedResult["@odata.count"];

        return result;
      });
  }

  public getPlanedServicesByServiceObjectPerPage(serviceObjectId: number, skip: number, count: number, sortBy: string, isDesc: boolean, filterOptions: PlannedServicesShortListFilterOptions): Observable<PagedResult<PlannedService>> {
    let params = new URLSearchParams;
    let filterRequestStrings: string[] = new Array();

    params.append('$orderby', sortBy + (isDesc ? " desc" : " asc"));
    params.append('$select', "Id,Name,Status,Deadline,FinishDate");
    params.append('$top', count ? count.toString() : null);
    params.append('$skip', skip ? skip.toString() : null)
    params.append('$count', "true");
    params.append('$expand', "ServiceObject");
    filterRequestStrings.push("ServiceObject/Id eq " + serviceObjectId);

    if (filterOptions) {

      if (filterOptions.isFinishedInTimeStatus == PlannedServicesShortListFilterOptions.IsFinishedInTimeStatus.FinishedInTime) {
        filterRequestStrings.push(
          "((Status eq ClientPersonalArea.Contracts.Model.PlannedServiceStatus'" + PlannedService.Status.Planned.toString() + "') and (" + moment().toISOString() + " Le Deadline)" +
          "or (Status eq ClientPersonalArea.Contracts.Model.PlannedServiceStatus'" + PlannedService.Status.Done.toString() + "') and (FinishDate Le Deadline))");
      }
      else if (filterOptions.isFinishedInTimeStatus == PlannedServicesShortListFilterOptions.IsFinishedInTimeStatus.Expired) {
        filterRequestStrings.push(
          "((Status eq ClientPersonalArea.Contracts.Model.PlannedServiceStatus'" + PlannedService.Status.Planned.toString() + "') and (" + moment().toISOString() + " Gt Deadline)" +
          "or (Status eq ClientPersonalArea.Contracts.Model.PlannedServiceStatus'" + PlannedService.Status.Done.toString() + "') and (FinishDate Gt Deadline))");
      }

      if (filterRequestStrings.length > 0)
        params.append('$filter', _.join(filterRequestStrings, ' and '));
    }

    return this._http.get("/api/odata/PlannedServices", params, true)
      .map(resp => {
        let pagedResult = resp.json();
        let result = new PagedResult<PlannedService>();

        var http = this._http;
        result.items = _.map(pagedResult.value, function (value) {
          return PlannedServiceService.convertPlannedServiceDTO2Object(http, value);
        });

        result.totalCount = pagedResult["@odata.count"];

        return result;
      });
  }

  public getPlannedServiceDetails(plannedServiceId: number): Observable<PlannedService>{

    let params = new URLSearchParams;
    params.append('$select', "Id,Name,Status,Deadline,FinishDate");
    params.append('$expand', "ServiceObject,Photos,Works($expand=Asset)");

    return this._http.get("/api/odata/plannedServices(" + plannedServiceId + ")", params, true)
      .map(resp => {
        return PlannedServiceService.convertPlannedServiceDTO2Object(this._http, resp.json());
      });
  }
}

export namespace PlannedServiceService {
  export function convertPlannedServiceDTO2Object(http: HttpBackendService, dto: any, plannedService: PlannedService = new PlannedService()): PlannedService {
    plannedService.id = dto.Id;
    plannedService.deadline = http.parseDate(dto.Deadline);
    plannedService.finishDate = dto.FinishDate == null ? null : http.parseDate(dto.FinishDate);
    plannedService.name = dto.Name;
    plannedService.status = this.convertPlannedServiceStatusDTO2Object(dto.Status);
    plannedService.serviceObject = dto.ServiceObject != null ? LocationService.convertLocationDTO2Object(dto.ServiceObject) : null;

    plannedService.works = [];
    plannedService.photos = [];

    if (dto.Works) {
      for (let work of dto.Works) {

        let newWork = new PlannedServiceWork();
        newWork.asset = AssetService.convertAssetDTO2Object(work.Asset);
        newWork.finishDate = dto.FinishDate;

        plannedService.works.push(newWork)
      }
    }

    if (dto.Photos) {
      for (let photo of dto.Photos) {
        let newPhotoData = new PlannedServicePhotoData();
        newPhotoData.blobServiceFileName = photo.BlobServiceFileName;
        newPhotoData.type = this.convertPhotoDataTypeDTO2ObjectPhotoType(photo.Type)

        plannedService.photos.push(newPhotoData);
      }
    }

    return plannedService;
  };

  export function convertPlannedServiceStatusDTO2Object(status: string): PlannedService.Status {
    switch (status) {
      case 'Planned': return PlannedService.Status.Planned;
      case 'Done': return PlannedService.Status.Done;
      case 'Canceled': return PlannedService.Status.Canceled;
      default: return;
    }
  }

  export function convertPhotoDataTypeDTO2ObjectPhotoType(photoType: string): PhotoType {
    switch (photoType) {
      case 'ContractPhotoByContractor':
        return PhotoType.ContractPhotoByContractor;
      case 'SurveyWarrantTaskPhotoByDispatcher':
        return PhotoType.SurveyWarrantTaskPhotoByDispatcher;
      case 'SurveyWarrantTaskPhotoByEngineer':
        return PhotoType.SurveyWarrantTaskPhotoByEngineer;
      case 'WarrantTaskPhotoByEngineer':
        return PhotoType.WarrantTaskPhotoByEngineer;
      default:
        return null;
    }
  }

}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/plannedService.service.ts